jQuery(window).on('load', function() {
    let menuLogo = jQuery('.mainHeader .header__column--center .header-logo');
    let menuUl = jQuery('.mainHeader .header__column--left .header-menu nav overflow-list');
    let liLenght = jQuery('.mainHeader .header__column--left .header-menu nav overflow-list > li').length;
    // menuUl.append(menuLogo.clone());
    // jQuery('.mainHeader .header__column--left .header-menu nav overflow-list > li').eq(n).css({'order', n});
    setTimeout(() => {
        jQuery('.mainHeader .header__column--left .header-menu nav overflow-list > li').each(function(index) {
            jQuery(this).css('order', index);
        });
    }, 1000);


    // jQuery('.mainHeader .header__column--left .header-menu nav overflow-list .header-logo').
});
$(document).ready(function(){
    // Click handler for navigation links
    // $(document).on('click', '.result-additional-info ul li a', function(e) {
    //     e.preventDefault();
    
    //     const targetId = $(this).attr('href').substring(1);
    //     const targetSlide = $('.maple-slider-wrapper .maple-slide[data-id="' + targetId + '"]');
    
    //     if (targetSlide.length) {
    //         let slideIndex = parseInt(targetSlide.attr('data-swiper-slide-index'));
            
    //         if (isNaN(slideIndex)) {
    //         $('.maple-slider-wrapper .maple-slide').each(function(index) {
    //             if ($(this).attr('data-id') === targetId) {
    //             slideIndex = index;
    //             return false;
    //             }
    //         });
    //         }
            
    //         mapleSwiper.slideToLoop(slideIndex, 500);
            
    //         setTimeout(function() {
    //         $('html, body').animate({
    //             scrollTop: $('.meetSliderWrap').offset().top - 20
    //         }, 500);
    //         }, 200);
    //     }
    // });


    // $('.custom-social-slider > .group-block-content').slick({
    //     centerMode: true,
    //     dots:false,
    //     arrows:false,
    //     centerMode: true,
    //     slidesToShow: 3,
    //     variableWidth: true,
    //     autoplay: true,
    //     autoplaySpeed: 100,
    //     // responsive: [
    //     //     {
    //     //     breakpoint: 768,
    //     //     settings: {
    //     //         dots:false,
    //     //         arrows:false,
    //     //         centerMode: true,
    //     //         centerPadding: '40px',
    //     //         slidesToShow: 3
    //     //     }
    //     //     },
    //     //     {
    //     //     breakpoint: 480,
    //     //     settings: {
    //     //         dots:false,
    //     //         arrows:false,
    //     //         centerMode: true,
    //     //         centerPadding: '40px',
    //     //         slidesToShow: 1
    //     //     }
    //     //     }
    //     // ]
    // });

    $('.custom-social-slider > .group-block-content').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,

    autoplay: true,
    autoplaySpeed: 0,
    speed: 2000,
    cssEase: 'linear',

    arrows: false,
    dots: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    swipe: false,
    touchMove: false
});
});



// Shop by Category Redirection on collections/all spcific filter
window.addEventListener('load', () => {
  const params = new URLSearchParams(window.location.search);
  const filter = params.get('filter');
  if (!filter) return;

  const waitForFilter = setInterval(() => {
    const filterSection = document.querySelector('.custom-product-filter');
    const targetBtn = filterSection?.querySelector(
      `.product-tag[data-product-tag="${filter}"]`
    );

    if (!filterSection || !targetBtn) return;

    clearInterval(waitForFilter);

    // Apply filter first
    targetBtn.click();

    // Wait for DOM to update after filtering
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const headerHeight =
          parseInt(getComputedStyle(document.documentElement)
            .getPropertyValue('--header-height')) || 0;

        const top =
          filterSection.getBoundingClientRect().top +
          window.pageYOffset -
          headerHeight -
          20;

        window.scrollTo({
          top,
          behavior: 'smooth'
        });
      });
    });
  }, 100);
});



// Shop Link Redirection & Filter Handling
window.addEventListener('load', () => {

  // SHOP MENU LINK HANDLER
  const shopLink = [...document.querySelectorAll('a.menu-list__link')]
    .find(link => link.textContent.trim() === 'Shop');

  if (shopLink) {
    shopLink.addEventListener('click', e => {
      e.preventDefault();

      const url = new URL(shopLink.href, window.location.origin);
      url.searchParams.set('filter', 'all');

      window.location.href = url.toString();
    });
  }

  // FILTER + SCROLL HANDLER
  const params = new URLSearchParams(window.location.search);
  const filter = params.get('filter');
  if (!filter) return;

  const waitForFilter = setInterval(() => {
    const filterSection = document.querySelector('.custom-product-filter');
    const targetBtn = filterSection?.querySelector(
      `.product-tag[data-product-tag="${filter}"]`
    );

    if (!filterSection || !targetBtn) return;

    clearInterval(waitForFilter);

    // Apply filter FIRST
    if (!targetBtn.classList.contains('active')) {
      targetBtn.click();
    }

    // Scroll AFTER layout stabilizes
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const headerHeight =
          parseInt(
            getComputedStyle(document.documentElement)
              .getPropertyValue('--header-height')
          ) || 0;

        const top =
          filterSection.getBoundingClientRect().top +
          window.pageYOffset -
          headerHeight -
          20;

        window.scrollTo({
          top,
          behavior: 'smooth'
        });
      });
    });

  }, 100);
});




